import ApiService from '@/services/api.service'
import SettingsService from '@/services/settings.service.js'
/* eslint-disable */
const state = {
}
const getters = {
}
const actions = {
    async getMetrics({ commit }){
        var settings = SettingsService.settings
        const url = settings.APIURL + 'metrics/websites/monitoring';//  'http://localhost:5015/api/metrics/websites/monitoring';
        return ApiService.get(url)
    }
}
const mutations = {
}
export const monitoring = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}